<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Detalle de actualidad</h4>
    <div *ngIf="movesLog && accessMP" class="p-3 mb-3 rounded" style="background-color: #f8f9fa; border: 1px solid #dee2e6;">
        <div class="form-group row">
            <label class="col-md-2 col-form-label">Creado</label>
            <div class="col-md-4">
                <p class="form-control-plaintext text-left">
                    {{ movesLog['creationLog']?.nameUser
                    ? (movesLog['creationLog']?.nameUser + ' - ' + (movesLog['creationLog']?.createdAt |
                    date:'dd/MM/yyyy HH:mm'))
                    : 'No se cuenta con registros del creador.' }}
                </p>
            </div>
            <label class="col-md-2 col-form-label">Editado</label>
            <div class="col-md-4">
                <p *ngIf="movesLog['editLog']" class="form-control-plaintext text-left">
                    {{ movesLog['editLog']?.nameUser }} - {{ movesLog['editLog']?.updatedAt | date:'dd/MM/yyyy HH:mm' }}
                </p>
                <p *ngIf="!movesLog['editLog']" class="form-control-plaintext text-left text-muted">
                    No se cuenta con registros de modificaciones.
                </p>
            </div>
        </div>
    </div>
    <hr>

    <div class="form-group row">

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Título</label>
            <input class="form-control" type="text" placeholder="Título" formControlName="title" autocomplete="off"
                [class.is-invalid]="campoNoValido('title')">
            <small class="text-danger" *ngIf="campoNoValido('title')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Autor</label>
            <input class="form-control" type="text" placeholder="Autor" formControlName="autor"
                [class.is-invalid]="campoNoValido('autor')">
            <small class="text-danger" *ngIf="campoNoValido('autor')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6 col-sm-12">
            <label class="form-label">Fecha de publicación</label>
            <input class="form-control" type="date" formControlName="date" [class.is-invalid]="campoNoValido('date')">
            <small class="text-danger" *ngIf="campoNoValido('date')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6 col-sm-12">
            <label class="form-label">Fecha de expiración</label>
            <input type="date" class="form-control" formControlName="dateexpiry">
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Sumilla</label>
            <textarea class="form-control" placeholder="Sumilla" formControlName="content"
                [class.is-invalid]="campoNoValido('content')" rows="5"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('content')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12 col-sm-12">
            <label class="form-label">Tags</label>
            <input class="form-control" type="text" placeholder="tag1. tag2, tag3, tag4, tag5" formControlName="tags">
        </div>

        <div class="textOnInput col-12 col-md-12 col-sm-12">
            <label class="form-label">URL de la fuente</label>
            <input class="form-control" type="text" placeholder="URL" formControlName="source"
                [class.is-invalid]="campoNoValido('source')">
            <small class="text-danger" *ngIf="campoNoValido('source')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Imagen</label>
            <div class="label-container ">
                <div class="row">
                    <div class="col-md-9">
                        <div class="input-group">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                    (click)="fileInput.click()">
                                    Cargar imagen
                                </button>
                            </div>
                            <input type="text" disabled class="form-control" placeholder="Imagen" formControlName="img">
                        </div>
                        <input #fileInput class="form-file" type="file" id="input-file" (change)="onFileChange($event)"
                            accept="image/png, .jpg, .webp" style="display: none;">
                    </div>
                    <div class="col-md-3">
                        <ng-container *ngIf="form.get('img').value != null">
                            <ng-container *ngIf="isUploadDir">
                                <img class="img-fluid" src="{{URL}}{{form.get('img').value}}" alt=""
                                    style="height: 120px; width:100px">
                            </ng-container>
                            <ng-container *ngIf="!isUploadDir">
                                <img src="{{form.get('img').value}}" alt="No se ha cargado una imagen"
                                    style="height: 50px;">
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Estado</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>